<template>
  <div class="home">
    <div class="home-header">
      <h2>数据大屏导航</h2>
      <p>选择下方任一大屏入口，进入对应的数据可视化页面（全屏展示）。</p>
    </div>

    <div class="card-grid">
      <div
        v-for="item in dashboards"
        :key="item.path"
        class="card"
        @click="go(item.path)"
      >
        <div class="card-icon">{{ item.icon }}</div>
        <div class="card-body">
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </div>
        <div class="card-footer">
          <span class="enter-link">进入大屏 →</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data () {
    return {
      dashboards: [
        {
          path: '/construction-data',
          icon: '🏗️',
          title: '施工养护综合数据',
          desc: '基于 DataV 的工程建设数据可视化大屏，含数字翻牌、排行榜、玫瑰图、水位图等。'
        },
        {
          path: '/electronic-file',
          icon: '📁',
          title: '机电设备电子档案',
          desc: '机电设备电子档案大屏，含左右两侧 ECharts 图表与中间数据概览。'
        },
        {
          path: '/manage-desk',
          icon: '🛠️',
          title: '机电运维管理台',
          desc: '机电运维综合管理台大屏，含顶部概览与底部图表/表格。'
        }
      ]
    }
  },
  methods: {
    go (path) {
      this.$router.push(path)
    }
  }
}
</script>

<style scoped>
.home-header {
  margin-bottom: 24px;
}

.home-header h2 {
  font-size: 22px;
  color: #303133;
  margin-bottom: 8px;
}

.home-header p {
  color: #909399;
  font-size: 14px;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.card {
  display: flex;
  flex-direction: column;
  padding: 24px;
  background: linear-gradient(135deg, #f0f7ff 0%, #ffffff 100%);
  border: 1px solid #e4e7ed;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.25s;
}

.card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(64, 158, 255, 0.15);
  border-color: #409eff;
}

.card-icon {
  font-size: 40px;
  margin-bottom: 16px;
}

.card-body {
  flex: 1;
}

.card-body h3 {
  font-size: 18px;
  color: #303133;
  margin-bottom: 10px;
}

.card-body p {
  font-size: 13px;
  color: #909399;
  line-height: 1.6;
}

.card-footer {
  margin-top: 18px;
}

.enter-link {
  color: #409eff;
  font-size: 14px;
  font-weight: 500;
}
</style>
